import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import StringConstants from 'app/shared/constants/StringConstants';
import QueryConstants from 'app/shared/constants/QueryConstants';

const contextUtils = {
    /**
     * Gets the marketing path value
     *
     * @param {string} search - The search query params
     * @return {string}
     */
    getMarketingPathVal(search) {
        const queryParams = ZRMUtils.queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH];
    },

    /**
     * Checks if the marketing search query parameter is application.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingApplicationsRoute(search) {
        const queryParams = ZRMUtils.queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.APPLICATIONS;
    },

    /**
     * Checks if the marketing search query parameter is payment.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingPaymentsRoute(search) {
        const queryParams = ZRMUtils.queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.PAYMENTS;
    },

    /**
     * Checks if the marketing search query parameter is leases.
     *
     * @param {string} search - The search query params
     * @return {bool}
     */
    isFromMarketingLeasesRoute(search) {
        const queryParams = ZRMUtils.queryUtils.parse(search);
        return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.LEASES;
    },
};

export default contextUtils;
